// extracted by mini-css-extract-plugin
export default {"wrapper":"StarredPackagesView_wrapper__57T8-","card":"StarredPackagesView_card__3khKn"};